import { debounce } from '@cian/newbuilding-utils';

const FILTER_CHANGE_TRACKING_DEBOUNCE_DELAY = 150;

export const debounceTracking = (trackingFn: (...args: unknown[]) => void) => {
  return debounce(FILTER_CHANGE_TRACKING_DEBOUNCE_DELAY, trackingFn);
};
